var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfGoods"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.FabricReport.BULK_SUMMARY'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Packed'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.fmediaPacked,"otherData":{
          mediaName: '大货成卷卷堆',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaPacked',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Unpacked'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.fmediaUnpacked,"otherData":{
          mediaName: '未成卷产品',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaUnpacked',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Packing_List'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.fmediaPackinglist,"otherData":{
          mediaName: '码单',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaPackinglist',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",attrs:{"columns":_vm.columns,"dataSource":_vm.data,"bordered":"","pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }